export const BASELINE_ROLE_PERMISSIONS = [
    'access_self_service',
    'check_in_attendance',
    'check_out_attendance',
    'list_attendance',
] as const;

export type BaselineRolePermission = (typeof BASELINE_ROLE_PERMISSIONS)[number];

export function isBaselineRolePermission(name: string): name is BaselineRolePermission {
    return (BASELINE_ROLE_PERMISSIONS as readonly string[]).includes(name);
}
